import MockApi from "./mockApi";
import {API} from "./env";
import {axiosInstance} from "./httpClient";

export const ApplicationStatus = {
    Canceled: 0,
    Declined: 100,
    PendingOtpConfirm: 200,
    PendingTransfer: 300,
    PendingApproval: 400,
    Transferred: 500,
    TransferReceipt: 600,
    Completed: 700
}

export class Applications {
    // this should be in sync with backend status

    static statusText = (status) => {
        switch (status) {
            case ApplicationStatus.Canceled:
                return "בוטל"
            case ApplicationStatus.Declined:
                return "נדחה"
            case ApplicationStatus.PendingApproval:
            case ApplicationStatus.PendingTransfer:
                return "ממתין להעברה"
            case ApplicationStatus.Transferred:
                return "הועבר"
            case ApplicationStatus.TransferReceipt:
                return "הועבר בהצלחה"
            case ApplicationStatus.Completed:
                return "הושלם"
            default:
                return "NONE"
        }
    }
}

export default class ApplicationsApi {

    static getAll = (status, startDate, endDate, companyId = null) => {

        if(MockApi.IsActive) {
            return MockApi.GetTransfers();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
        };
        if(startDate && endDate) {
            body['startDate'] = startDate;
            body['endDate'] = endDate;
        }
        if(status && status.length > 0) {
            body['status'] = status;
        }
        if(companyId) {
            body['companyId'] = companyId;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/company/applications/list`, JSON.stringify(body), config);
    };

    static updateStatus = (status, applications, bankReference = null, bankActivityReference = null) => {
        let idsArray = [];
        for(const application of applications) {
            idsArray.push(application.id);
        }
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            id: idsArray,
            status: status
        };

        // Add bank references if provided
        if (bankReference) {
            body.bankReference = bankReference;
        }

        if (bankActivityReference) {
            body.bankActivityReference = bankActivityReference;
        }

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/applications/status`, JSON.stringify(body), config);
    };

    static updateNotes = (applicationId, description) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            applicationId: applicationId,
            description: description
        };

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/applications/notes`, JSON.stringify(body), config);
    };

    static downloadApprovalPdf = async (applicationId) => {
        const userInfo = JSON.parse(localStorage.getItem('user'));
        const config = {
            headers: { 'Authorization': 'Bearer ' + userInfo.token },
            responseType: 'arraybuffer',
        };
        const res = await axiosInstance.post(
            `${API}/applications/approval-pdf`,
            { applicationId },
            config
        );
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `approval-${applicationId}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
    };

    static fetchApprovalPdfBuffer = async (applicationId) => {
        const userInfo = JSON.parse(localStorage.getItem('user'));
        const config = {
            headers: { 'Authorization': 'Bearer ' + userInfo.token },
            responseType: 'arraybuffer',
        };
        const res = await axiosInstance.post(
            `${API}/applications/approval-pdf`,
            { applicationId },
            config
        );
        return res.data;
    };

    static getApplicationDetails = (applicationId) => {
        if(MockApi.IsActive) {
            return MockApi.GetApplicationDetails();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            applicationId: applicationId
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/applications/details`, JSON.stringify(body), config);
    };
}

